export const offers =[
    {
        id:0,
        title:'Get Discount of Flat Rs. 98 on purchasing 3 subjects !',
        discount:98,
        minimumCartQuantity:3,
    },
    {
        id:1,
        title:'Get Discount of Flat Rs. 197 on purchasing 4+ subjects !',
        discount:197,
        minimumCartQuantity:4,
    }
]